/* tslint:disable */
/* eslint-disable */
/**
 * scissors
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpandResponse
 */
export interface ExpandResponse {
    /**
     * 
     * @type {string}
     * @memberof ExpandResponse
     */
    content: string;
}

/**
 * Check if a given object implements the ExpandResponse interface.
 */
export function instanceOfExpandResponse(value: object): value is ExpandResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ExpandResponseFromJSON(json: any): ExpandResponse {
    return ExpandResponseFromJSONTyped(json, false);
}

export function ExpandResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpandResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function ExpandResponseToJSON(value?: ExpandResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'],
    };
}

